/** Kapak JPEG çıktısı ve önizleme/rapor hizası — tek kaynak */
export const COVER_EXPORT_WIDTH = 1200;
export const COVER_EXPORT_HEIGHT = 630;
/** CSS `aspect-ratio` */
export const COVER_EXPORT_ASPECT_RATIO = `${COVER_EXPORT_WIDTH} / ${COVER_EXPORT_HEIGHT}` as const;
/** Önizleme çerçevesi görsel olarak 240 px yüksekliğe kadar ölçeklenir. */
export const COVER_PREVIEW_MAX_HEIGHT_PX = 240;
/** En-boy oranını bozmadan kullanılan karşılık gelen üst genişlik sınırı. */
export const COVER_PREVIEW_MAX_WIDTH_PX = Math.round(
  (COVER_PREVIEW_MAX_HEIGHT_PX * COVER_EXPORT_WIDTH) / COVER_EXPORT_HEIGHT
);
